var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "CirclePlusFilled",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-circle-plus-filled","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M250 124.94C250 193.917 193.962 250 124.995 250 56.049 250 0 193.916 0 125.049 0 56.17 56.049 0 124.898 0 193.843 0 250 55.954 250 124.94zM134.594 75h-19.327v38.66H75v19.325h40.267V174h19.327v-41.015H174V113.66h-39.406V75z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/circle-plus-filled.svg